import { useState, useEffect } from 'react'
import Header from './Header'
import Sidebar from './Sidebar'
import Notification from '../common/Notification'

const Layout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false)

  const handleMenuToggle = () => {
    setSidebarOpen(!sidebarOpen)
  }

  const handleSidebarClose = () => {
    setSidebarOpen(false)
  }

  // Add/remove body class for mobile drawer
  useEffect(() => {
    if (sidebarOpen) {
      document.body.classList.add('drawer-open')
    } else {
      document.body.classList.remove('drawer-open')
    }
    
    return () => {
      document.body.classList.remove('drawer-open')
    }
  }, [sidebarOpen])

  // Close sidebar on route change (for mobile)
  useEffect(() => {
    handleSidebarClose()
  }, [children])

  return (
    <>
      <Header onMenuToggle={handleMenuToggle} />
      <Sidebar isOpen={sidebarOpen} onClose={handleSidebarClose} />
      <main className="admin-main">
        <Notification />
        {children}
      </main>
    </>
  )
}

export default Layout
